import Vue from 'vue'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import store from '@/store'

// Routes
import paths from './paths'

function route (path, view, name, props, meta, children) {
  if (typeof children === 'undefined') {
    return {
      name: name || view,
      path,
      props: props || false,
      meta: meta || [],
      children: children || [],
      component: () => import(`@/views/${view}.vue`)
    }
  } else {
    return {
      path,
      props: props || false,
      meta: meta || [],
      children: children || [],
      component: () => import(`@/views/${view}.vue`)
    }
  }
}

Vue.use(VueRouter)

// Create a new router
const router = new VueRouter({
  mode: 'history',
  routes: paths.map(path => route(path.path, path.view, path.name, path.props, path.meta, path.children)).concat([
    {path: '*', redirect: '/'}
  ])
})

Vue.use(Meta)

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.noAuth)) {
    next()
  } else {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js